<template>
  <NetworkProfileDescriptionList :item="model" />
</template>

<script setup lang="ts">
import { NetworkProfile } from '@infuse/e-connector/network-profile/domain';
import { NetworkProfileDescriptionList } from '@infuse/e-connector/network-profile/ui';

interface Props {
  model: NetworkProfile;
}
withDefaults(defineProps<Props>(), {});
</script>
